/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData
 */
export interface FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData
     */
    AccessToken: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData
     */
    RefreshToken: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData(value: object): value is FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData {
    if (!('AccessToken' in value) || value['AccessToken'] === undefined) return false;
    if (!('RefreshToken' in value) || value['RefreshToken'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSON(json: any): FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'AccessToken': json['AccessToken'],
        'RefreshToken': json['RefreshToken'],
    };
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSON(json: any): FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSONTyped(value?: FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AccessToken': value['AccessToken'],
        'RefreshToken': value['RefreshToken'],
    };
}

